/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddMenuCategoryDto as DigiworkMaitreDPosDtoMenuCategoriesAddMenuCategoryDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuCategories/add-menu-category-dto';
import { MenuCategoryDto as DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto } from '../../models/Digiwork/MaitreD/Pos/DTO/MenuCategories/menu-category-dto';

export interface AddMenuCategory$Params {
      body?: DigiworkMaitreDPosDtoMenuCategoriesAddMenuCategoryDto
}

export function addMenuCategory(http: HttpClient, rootUrl: string, params?: AddMenuCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto>> {
  const rb = new RequestBuilder(rootUrl, addMenuCategory.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoMenuCategoriesMenuCategoryDto>;
    })
  );
}

addMenuCategory.PATH = '/api/menu-categories';
